import { CurrencyPipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { ToastrModule } from 'ngx-toastr';

import { FooterComponent } from '@core/components/footer/footer.component';
import { HeaderComponent } from '@core/components/header/header.component';
import { cookieConsentConfig } from '@core/config/cookie-consent';
import { HttpRequestInterceptor } from '@core/interceptors/http-request.interceptor';
import { TpWatermarkComponent } from '@shared/components/tp-watermark/tp-watermark.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

registerLocaleData(ptBr);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HeaderComponent,
    FooterComponent,
    FontAwesomeModule,
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    TpWatermarkComponent,
    NgcCookieConsentModule.forRoot(cookieConsentConfig),
  ],
  providers: [
    CurrencyPipe,
    DecimalPipe,
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
      deps: [Router],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
